import { render, staticRenderFns } from "./complaint-attachments-tab.vue?vue&type=template&id=2eb0bc88"
import script from "./complaint-attachments-tab.vue?vue&type=script&lang=js"
export * from "./complaint-attachments-tab.vue?vue&type=script&lang=js"
import style0 from "./complaint-attachments-tab.vue?vue&type=style&index=0&id=2eb0bc88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports